const mcuDashboardRoutes = [
    {
        path: '/mcu-booking/dashboard',
        redirect: '/mcu-dashboard'
    },
    {
        path: '/mcu-dashboard',
        name: 'mcuDashboardRoot',
        children: [
            {
                path: '',
                name: 'mcuDashboard',
                component: () => import('@/modules/mcu_dashboard/Dashboard.vue'),
                meta: {
                    resource: 'mcu_dashboard',
                    action: 'view',
                    layout: 'default',
                    auth: true,
                    title: 'MCU Dashboard',
                    breadcrumbs: [
                        { title: 'Booking Management', routeName: 'mcuBookingList' },
                        { title: 'Dashboard', routeName: 'mcuDashboard' }
                    ]
                }
            }
        ]
    }
]

export default mcuDashboardRoutes
